module.exports = __webpack_public_path__ + "img/default-board.88abe5f2.svg";